import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicStylesheetComponent } from './dynamic-stylesheet.component';

@NgModule({
  declarations: [DynamicStylesheetComponent],
  exports: [DynamicStylesheetComponent],
  imports: [CommonModule],
})
export class DynamicStylesheetModule {}
